// React Imports
import React, { useContext, useEffect, useState } from "react";

// Package Imports
import { Container, Row, Col } from "react-bootstrap";
import { observer } from "mobx-react";
import { toJS } from "mobx";

// Project Imports
import { TitleTextSubtextBottom } from "../../components";
import ChooseNeedsForm from "./components/form/choose-needs";
import ChooseNeedsFormController from "./components/form/choose-needs/controller";
import AuthStore from "modules/login/store/AuthStore";
import FormContext from "context/FormContext";
import savePragatiNAInboundData from "utils/savePragatiNAInboundData";

// CSS Imports
import "./choose-needs-and-set-targets.css";
import getCookie from "utils/journeyIdCookie/getJourneyId";
import { COOKIE_PARA_NAME_FOR_JOURNEY_ID } from "../../constants/Constants";
import StorageKeys from "constants/StorageKeys";
import PreNeedSelectionModalStore from "modules/pre-need-selection-modal/store/PreNeedSelectionModalStore";
import QmsStorageKeys from "constants/QmsStorageKeys";



const ChooseNeedsAndSetTargets = (props) => {
  const [formController, setFormController] = useState(undefined);
  const formContext = useContext(FormContext)
  let isUlipUser = localStorage.getItem(StorageKeys.ULIP_TRAINING) === "1"
  let designation_code = localStorage.getItem(QmsStorageKeys.ORIGANAL_DESIGNATION_CODE);
  let isposp = designation_code ? designation_code?.toLowerCase().includes('posp') : false
  localStorage.setItem(StorageKeys.IS_POSP, isposp)

  // let subChannelCode = localStorage.getItem(StorageKeys.SUB_CHANNEL_CODE)

  useEffect(() => {
    if (AuthStore.journeyData !== undefined && formController == undefined) {
      let formController = new ChooseNeedsFormController();
      let journeyId = getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID);
      let journeyData = toJS(AuthStore.journeyData);
      formController.setDefaults(journeyId, journeyData);
      formContext.setFormController(formController)
      setFormController(formController);
    }
  }, [AuthStore.journeyData, formController]);

  useEffect(() => {
    if (AuthStore.journeyData !== undefined && formController !== undefined && PreNeedSelectionModalStore.selectedProduct === "select_product_&_generate_quote") {
      let formController = new ChooseNeedsFormController();
      let journeyId = getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID);
      let journeyData = toJS(AuthStore.journeyData);
      formController.setDefaults(journeyId, journeyData);
      formContext.setFormController(formController)
      setFormController(formController);
    }
  }, [isUlipUser,isposp]);

  useEffect(() => {
      savePragatiNAInboundData(location)
  }, []);

  if (formController === undefined) return null;
  return (
    <Container className='mt-3 pt-1 pb-2 pb-md-4 choose-needs-and-set-targets margin-bottom-135'>
      <Row>
        <Col className='col-12 col-md-9 mb-3 mb-lg-0 mt-4 mt-lg-0'>
          <TitleTextSubtextBottom
            title={
              <span>
                Choose Needs <span className='font-weight-light'>&</span> Set Targets
              </span>
            }
            subText='The popular ones are already selected'
          />
        </Col>
      </Row>
      <ChooseNeedsForm formController={formController} {...props} />
    </Container>
  );
};

export default observer(ChooseNeedsAndSetTargets);
